import API from "common-ui-components/components/utils/API";

export const executePowerOption = (deviceId, option) =>
  API.post(
    `/devices/power-option?command=${encodeURIComponent(option)}`,
    [deviceId],
  );
